var common = require("../../utiles/common.js")
var service = require("../../utiles/service")

module.exports = {
    register: function () {
        document.createElement('notice-list')
        ko.components.register('notice-list', {
            viewModel: function (params) {
                var $this = this;
                var pageIndex = 1;
                $this.isNumber = ko.observable(true);
                $this.key = ko.observable(false);
                $this.notices = ko.observableArray();

                $this.updateNoticeTotal = function(){
                    $this.key(!$this.key());
                    $this.getList(1);
                }

                $this.getList = function(index){
                    if(!$this.isNumber()&&!index)return false;
                    $this.isNumber(false)
                    if(!index){
                        pageIndex++;
                    }else{
                        pageIndex=1;
                    }
                    var param={
                        pageSize:10,
                        pageNumber:index?index:pageIndex,
                    }
                    console.log("pageIndex----------"+pageIndex)
                    var res = service.config.findAll(param);
                    $this.isNumber(true);
                    $(".zxf_pagediv").createPage({
                        total:res.totalNumber,
                        pageNum: res.totalPage,
                        current: res.pageNumber,
                        backfun: function(e) {
                            param.pageNumber = e.current;
                            res = service.config.findAll(param);
                            $this.notices(res.data);
                        }
                    });
                    if(res.data&&res.data.length<10){
                        $this.isNumber(false)
                    }
                    $this.notices(res.data);
                };
                $this.getList(1);

            },
            template: require("./noticeList.html")
        });
        document.createElement('notice-item')
        ko.components.register('notice-item', {
            viewModel: function (params) {
                var $this = this;
                $this.data = params.app;
                $this.time = common.timestampToTime(params.app.createdDate);
                $this.vis = ko.observable(false);
                $this.id = ko.observable();
                $this.read = ko.observable(false);
                $this.unfold = function(read,id){
                    this.vis(true);
                    $this.id(id);
                    $this.read(read);
                }
                $this.unfoldClose = function(){
                    this.vis(false);
                    if(!this.read()){
                        service.config.userRead(this.id());
                        params.updateNoticeTotal();
                    }
                }

            },
            template: require("./noticeItem.html")
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/component/systemNotice/Notice.js
// module id = 158
// module chunks = 0